import React from 'react';

import type { EventScheduleData, EventBookingCategoryData } from '@/features/booking/types/ticketBookingTypes';
import { TierRibbon } from './TierRibbon';

interface EventDetailsSectionProps {
  eventSchedule: EventScheduleData;
  eventBookingCategory?: EventBookingCategoryData | null;
}

const EventDetailsSection: React.FC<EventDetailsSectionProps> = ({
  eventSchedule,
  eventBookingCategory
}) => {
  // Get timezone from event schedule
  const timezone = eventSchedule?.timezone_id;
  
  // Get tier class from booking category
  const tierClass = eventBookingCategory?.booking_category?.class || 'Standard';

  return (
    <div className="bg-black py-2">
      <TierRibbon
        tierClass={tierClass}
        variant="date-tier"
        startTime={eventSchedule?.start_time}
        timezoneId={timezone}
        textSuffix="TIER"
        fullWidth={true}
      />
    </div>
  );
};

export default EventDetailsSection;
